export const iconProps = {
  width: 80,
  height: 80,
  iconProps: {
    width: 45,
    height: 45,
  },
}
